import { NETWORK_ERROR_TITLE } from "../constants/otherErrorPatterns";
import type { UserFriendlyError } from "../types";

/**
 * Corrélation requestId : distingue un échec réseau (aucune réponse serveur) d'une vraie erreur
 * serveur. Un `requestId` n'existe que si une réponse serveur a atteint le client :
 * - message shaped « réseau » alors qu'une réponse existe → requalifié en erreur serveur avec référence ;
 * - erreur serveur 5xx → référence ajoutée au message pour le support ;
 * - pas de requestId (failed to fetch / connection reset) → message d'échec réseau conservé.
 */
export function applyRequestIdCorrelation(
	friendly: UserFriendlyError,
	requestId: string | null,
	status: number | null,
): UserFriendlyError {
	if (!requestId) {
		return friendly;
	}
	if (friendly.title === NETWORK_ERROR_TITLE) {
		return {
			title: "Erreur serveur",
			message: `Le serveur a répondu avec une erreur. Réessayez ou communiquez cette référence au support : ${requestId}.`,
			canRetry: true,
		};
	}
	if (status !== null && status >= 500) {
		return {
			...friendly,
			message: `${friendly.message} Référence support : ${requestId}.`,
		};
	}
	return friendly;
}
